var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-section container px-3"},[(_vm.infos.length > 0)?_c('b-row',_vm._l((_vm.infos),function(data,i){return _c('TradeShowList',{key:i,attrs:{"data":data}})}),1):_c('b-row')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }